import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  ButtonBase,
} from "@reusejs/react";

let sectionHeader = {
  title: "Our Experts",
  description: "We are always available to assist you in acquiring a property",
};

const Actions = () => {
  return (
    <div className="mt-8 flex justify-center">
      <div className="mr-2">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Talk to our Expert"
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            padding: "px-4 py-3",
          }}
        />
      </div>
      <ButtonBase
        variant="primary"
        type="submit"
        label="Know more"
        onClick={() => {
          console.log("button clicked");
        }}
        buttonBaseClasses={{
          font: "text-sm font-medium",
          backgroundColor: "bg-transparent",
          textColor: "text-black hover:text-blue-700",
          border: "border border-black border hover:border-blue-700",
        }}
      />
    </div>
  );
};

export default function ExpertsComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20 bg-gray-50",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
      }}
    >
      <IconTitleDescriptionActionCard
        title={sectionHeader.title}
        description={sectionHeader.description}
        actions={<Actions />}
        itemTitleDescriptionCardBaseClasses={{
          iconWrapper:
            "flex h-12 w-12 items-center justify-center rounded-md text-white",
          titleWrapper: "mt-2 text-center",
          titleStyles: "text-3xl font-extrabold sm:text-4xl",
          descriptionWrapper: "text-center mt-3 sm:mt-4 max-w-3xl mx-auto",
          descriptionStyles: "text-lg text-gray-500",
          actionWrapper: "mt-2 text-left",
        }}
      />
    </SectionContainerBase>
  );
}
